// sizes
// export const BTN_SIZE_XS = "BTN_SIZE_XS";
export const BTN_SIZE_SM = "BTN_SIZE_SM";
export const BTN_SIZE_MD = "BTN_SIZE_MD";

// Types
export const BTN_TYPE_PRIMARY = "BTN_TYPE_PRIMARY";
export const BTN_TYPE_SECONDARY = "BTN_TYPE_SECONDARY";
export const BTN_TYPE_SECONDARY_WHITE = "BTN_TYPE_SECONDARY_WHITE";
export const BTN_TYPE_SECONDARY_LIGHT = "BTN_TYPE_SECONDARY_LIGHT";
export const BTN_TYPE_BORDER_SECUNDARY = "BTN_TYPE_BORDER_SECUNDARY";
export const BTN_TYPE_TRANSPARENT = "BTN_TYPE_TRANSPARENT";
export const BTN_TYPE_GRAY = "BTN_TYPE_GRAY";
// Icons
export const BTN_ICON_PLAY = "BTN_ICON_PLAY";
export const BTN_ICON_SAC = "BTN_ICON_SAC";
export const BTN_ICON_SEARCH = "BTN_ICON_SEARCH";
export const BTN_ICON_SOUND = "BTN_ICON_SOUND";
export const BTN_ICON_ADD_USER = "BTN_ICON_ADD_USER";
export const BTN_ICON_ADD_MANY_USERS = "BTN_ICON_ADD_MANY_USERS";
export const BTN_ICON_INFO = "BTN_ICON_INFO";

export const BTN_ICON_PRINT = "BTN_ICON_PRINT";
export const BTN_ICON_EDIT = "BTN_ICON_EDIT";
export const BTN_ICON_BIN = "BTN_ICON_BIN";
export const BTN_ICON_CALENDAR = "BTN_ICON_CALENDAR";

export const BTN_FLAG_BR = "BTN_FLAG_BR";
export const BTN_FLAG_USA = "BTN_FLAG_USA";
